import React from 'react';
import { Link } from 'react-router-dom';
// 导入 Header（路径要和你项目中 Header 的位置一致）

// 导入 Footer（路径要和你项目中 FooterItem 的位置一致）


const NotFound = ({ loggedInUser, onLogout }) => {
  return (
    <div>
      {/* 显示博客头部 */}
  
      {/* 404 提示内容 */}
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h1>404 - 页面找不到</h1>
        <p>你访问的页面不存在～</p >
        <Link to="/">
          <button 
            style={{ 
              padding: '8px 16px', 
              backgroundColor: '#1890ff', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer' 
            }}
          >
            返回首页
          </button>
        </Link>
      </div>
      {/* 显示博客底部 */}

    </div>
  );
};

export default NotFound;
